export const COMPANY = {
  name: "Al Maler Mester ApS",
  cvr: "43281291",
  street: "Tårnvej 21, st. th.",
  city: "2610 Rødovre",
  phone: "+45 91 65 44 29",
  phoneDisplay: "91 65 44 29",
  phoneHref: "tel:+4591654429",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { to: "/", label: "Forside" },
  { to: "/ydelser", label: "Ydelser" },
  { to: "/erhverv", label: "Erhverv" },
  { to: "/projekter", label: "Projekter" },
  { to: "/om-os", label: "Om os" },
  { to: "/kontakt", label: "Kontakt" },
];

export const SERVICES = [
  {
    nr: "01",
    title: "Erhvervsmaling",
    desc: "Professionel maling af kontorer, erhvervslokaler, butikker, lagerhaller og andre erhvervsejendomme.",
    image: "/images/office.jpg",
  },
  {
    nr: "02",
    title: "Nybyggeri",
    desc: "Malerarbejde i forbindelse med nybyggeriprojekter, herunder vægge, lofter og øvrige relevante overflader.",
    image: "/images/construction.jpg",
  },
  {
    nr: "03",
    title: "Renovering",
    desc: "Maleropgaver i forbindelse med renoverings- og ombygningsprojekter – fra enkelte etager til større entrepriser.",
    image: "/images/renovation.jpg",
  },
  {
    nr: "04",
    title: "Kontorer & erhvervslokaler",
    desc: "Maling og istandsættelse af kontorer, arbejdspladser og erhvervsfaciliteter med fokus på minimal gener for driften.",
    image: "/images/corridor.jpg",
  },
  {
    nr: "05",
    title: "Butikker & erhvervsejendomme",
    desc: "Professionel maling af butikslokaler, fællesarealer og erhvervsejendomme – planlagt efter jeres åbningstider og drift.",
    image: "/images/warehouse.jpg",
  },
  {
    nr: "06",
    title: "Flyttelejemål",
    desc: "Maling og klargøring af erhvervslejemål i forbindelse med lejerskifte, aflevering og flytning.",
    image: "/images/office.jpg",
  },
  {
    nr: "07",
    title: "Underentreprise",
    desc: "Vi indgår som malerunderentreprenør for entreprenører, byggefirmaer og andre professionelle samarbejdspartnere.",
    image: "/images/facade.jpg",
  },
  {
    nr: "08",
    title: "Spartling og klargøring",
    desc: "Grundig klargøring af overflader før maling, herunder relevant spartling, forbehandling og finish.",
    image: "/images/detail.jpg",
  },
  {
    nr: "09",
    title: "Vægge og lofter",
    desc: "Professionel maling og finish af vægge og lofter på erhvervsprojekter – med et ensartet og holdbart slutresultat.",
    image: "/images/hero.jpg",
  },
];

export const B2B_CATEGORIES = [
  "Entreprenører",
  "Byggefirmaer",
  "Ejendomsselskaber",
  "Boligforeninger",
  "Facility management-virksomheder",
  "Kontorer",
  "Detailbutikker",
  "Lager- og erhvervsejendomme",
  "Andre professionelle virksomheder",
];

export const REASONS = [
  {
    nr: "01",
    title: "B2B-specialist",
    desc: "Vi arbejder målrettet med erhvervskunder og professionelle samarbejdspartnere – og kun dem.",
  },
  {
    nr: "02",
    title: "Fleksibel kapacitet",
    desc: "Vi kan indgå på både enkeltstående opgaver og større projekter, når jeres tidsplan kræver det.",
  },
  {
    nr: "03",
    title: "Professionel koordinering",
    desc: "Vi samarbejder effektivt med entreprenører, projektledere og øvrige faggrupper på byggepladsen.",
  },
  {
    nr: "04",
    title: "Fokus på deadlines",
    desc: "Vi forstår betydningen af tidsplaner på erhvervs- og byggeprojekter – og holder, hvad vi aftaler.",
  },
  {
    nr: "05",
    title: "Kvalitet i udførelsen",
    desc: "Vi arbejder med fokus på et professionelt og ensartet slutresultat, hver eneste gang.",
  },
];

export const PROCESS_STEPS = [
  {
    nr: "1",
    title: "Kontakt",
    desc: "Virksomheden kontakter os med information om opgaven.",
  },
  {
    nr: "2",
    title: "Gennemgang",
    desc: "Vi gennemgår projektets omfang, tidsplan og krav.",
  },
  {
    nr: "3",
    title: "Tilbud og planlægning",
    desc: "Der aftales pris, arbejdsomfang og udførelsesperiode.",
  },
  {
    nr: "4",
    title: "Udførelse",
    desc: "Opgaven udføres professionelt og koordineres efter den aftalte tidsplan.",
  },
];

export const OPGAVE_TYPER = [
  ...SERVICES.map((s) => s.title),
  "Andet",
];

export const OPSTART_OPTIONS = [
  "Hurtigst muligt",
  "Inden for 1 måned",
  "1–3 måneder",
  "Mere end 3 måneder",
  "Fleksibelt / endnu ikke afklaret",
];
